<div class="image-editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <!-- Dropdown menu -->
  <div class="editor-content" *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['image']['width']" [height]="class['image']['height']"
        (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>

    <!-- Số thứ tự của hình ảnh muốn hiển thị  -->
    <div *ngIf="!objectChoosing.type?.includes('news')"
    class="d-flex justify-content-between align-items-center" nz-tooltip nzTooltipPlacement="left"
    [nzTooltipTitle]="'neu_so_thu_tu_cua_hinh_anh_muon_hien_thi_khong_co_thi_mac_dinh_se_lay_hinh_anh_dau_tien_de_hien_thi' | translate">
      <p class="mb-0 my-2" style="width: 50%;">{{'so_thu_tu_cua_hinh_anh_muon_hien_thi' | translate}}</p>
      <nz-input-number [nzMin]="1" [nzStep]="1" [ngModel]="config.selected_image_index"
        (nzBlur)="updateConfig()" (ngModelChange)="config.selected_image_index = $event">
      </nz-input-number>
    </div>

    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình object-fit -->
      <li nz-submenu nzTitle="{{'do_bao_phu' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <app-object-fit-config
                    [device]="device"
                    [class]="class"
                    [objectFitClass]="class['image__boundary--img']"
                    [style_field]="style_fields[2]"
                    (isViewAll)="openViewAll($event)"
                    [objectChoosing]="objectChoosing">
        </app-object-fit-config>
      </li>
      <!-- Cấu hình filter -->
      <li nz-submenu nzTitle="{{'anh_sang_va_tuong_phan' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
          <app-filter-config
              [device]="device"
              [class]="class"
              [config]="config"
              [filterConfig]="config['filter']"
              [opacityClass]="class['image__boundary--img']"
              [id_object]="objectChoosing._id"
              [style_field]="style_fields[1]"
              (isViewAll)="openViewAll($event)">
          </app-filter-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [device]="device"
                            [class]="class"
                            [borderClass]="class['image__boundary--img']"
                            [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing"
        >
        </app-borders-config>
        <!-- Nút mở rộng -->

        <div class="item-border my-3 cursor-pointer" style="float: right">
          <p class="m-0 title-border" (click)="openViewAll(style_fields[3])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- Tạo bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <!-- Cấu hình bóng -->
        <app-shadow-config
            [device]="device"
            [config]="config"
            [class]="class"
            [shadowClass]="class['image__boundary--img']"
            [shadowConfig]="config['box-shadow']"
            [objectChoosing]="objectChoosing"
            >
        </app-shadow-config>
      </li>
      <!-- Cấu hình lật ảnh -->
      <li nz-submenu nzTitle="{{'lat_hinh' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="editor-field-body">
          <div class="mb-3">
            <div class="field-row-sub">
              <div style="display: flex; gap: 4px; width: 100%">
                <span nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('y')"
                  class="btn_transform">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z">
                    </path>
                  </svg>
                  <p class="m-0">{{'ngang' | translate}}</p>
                </span>
                <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('x')"
                  class="btn_transform">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z">
                    </path>
                  </svg>
                  <p class="m-0">{{'doc' | translate}}</p>
                </button>
              </div>
            </div>
          </div>
          <div class="field-row mb-3">
            <div class="field-row-sub">
              <div style="display: flex; gap: 4px; width: 100%">
                <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                  (click)="handleSetTransform('-z')">
                  <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                  <p class="m-0">{{"trai" | translate}}</p>
                </button>
                <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                  (click)="handleSetTransform('z')">
                  <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                  <p class="m-0">{{'phai' | translate}}</p>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="view">
          <p class="discover_text" (click)="openViewAll(style_fields[6])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{'mo_rong' | translate}}
          </p>
          <span nz-icon nzType="arrow-right" nzTheme="outline"></span>
        </div>
      </li>
      <!-- Xem toàn màn hình -->
      <li nz-submenu nzTitle="{{'xem_toan_man_hinh'| translate}}"
      [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
        <!-- Bật tắt chức năng cấu hình toàn màn hình -->
        <div class="field-row" nz-tooltip [nzTooltipTitle]="'khi_click_hinh_anh_se_phong_to_ra_toan_man_hinh' | translate">
          <span class="mx-2 w-50">{{'toan_man_hinh' | translate}}</span>
          <nz-switch [ngModel]="config['image-fullscreen']?.['toggle_fullscreen']"
          (ngModelChange)="config['image-fullscreen']['toggle_fullscreen'] = $event;updateConfig()"
          class="mx-2">
          </nz-switch>
        </div>

        <ng-container *ngIf="config['image-fullscreen']?.['toggle_fullscreen']">
          <!-- Bật tắt mở preview toàn màn hình ở design để cấu hình -->
          <div class="item-border my-3 cursor-pointer" style="float: right">
            <p class="m-0 title-border" (click)="handleOpenFullscreenPreview()">
              {{ 'xem_truoc' | translate }} &#8594;
            </p>
          </div>
        </ng-container>
      </li>

      <!-- Hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <app-choose-animations-config
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [cursorClass]="class['image']"
          [effect_hover]="effect_hover"
          [customize]="customize"
          [type]="'object'"
          [effectFileUsing]="'image'">
        </app-choose-animations-config>
      </li>
      <!-- KHẢ NĂNG TRUY CẬP -->
      <li nz-submenu nzTitle="{{'kha_nang_truy_cap' | translate}}" [(nzOpen)]="openMap.menu15" (nzOpenChange)="openHandler('menu15')"
      nz-tooltip [nzTooltipTitle]="'*_giai_thich_anh_lcp' | translate">
        <div class="field-row" style="margin: 0">
          <div class="field-row-sub field-row__switch" style="padding: 0" >
            <span> {{'uu_tien_tai_truoc' | translate}} </span>
            <nz-switch [(ngModel)]="config.is_top_page" (ngModelChange)="updateConfig()"></nz-switch>
          </div>
        </div>
      </li>
      <!-- Upload ảnh -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="upload-image" *ngIf="!isViewAll">

          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </div>
  <!-- Mở rộng -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình filter chi tiết -->
    <div class="editor-field-body m-1 mt-2" *ngIf="currentViewAll.index == 2">
      <app-brightness-contrast-config
                [device]="device"
                [class]="class"
                [config]="config"
                [filterConfig]="config['filter']"
                [opacityClass]="class['image__boundary--img']"
                [staticdata]="staticdata"
                [id_object]="objectChoosing._id">
      </app-brightness-contrast-config>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['image__boundary--img']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 6">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
    <!-- Mở rộng hình dạng ảnh-->
    <div class="editor-field-body p-0" *ngIf="currentViewAll.index == 7">
      <div class="editor-field-body">
        <div class="field-row">
          <!-- <div class="d-flex justify-content-between mt-2 align-items-start">
            <p class="font-weight-bold">Hiển thị trục đối tượng</p>
            <nz-switch [(ngModel)]="config.image.show_axis" (ngModelChange)="updateConfig()"></nz-switch>
          </div> -->
          <p style="font-weight: 500; font-size: 16px">{{'lat_hinh' | translate}}</p>
          <div class="field-row-sub">
            <div style="display: flex; gap: 4px; width: 100%">
              <span nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('y')" class="btn_transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z">
                  </path>
                </svg>
                <p class="m-0">{{'ngang' | translate}}</p>
              </span>
              <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('x')"
                class="btn_transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z">
                  </path>
                </svg>
                <p class="m-0">{{'doc' | translate}}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item mt-2" style="min-height: 32px">
            <p class="m-0">{{'ngang' | translate}}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateY"
              (ngModelChange)="SetTransform()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateY"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()"></nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'doc' | translate}}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateX"
              (ngModelChange)="handleSetTransform('y')">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateX"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()"></nz-slider>
        </div>
      </div>
      <br />
      <!-- Xoay hình ảnh -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div style="justify-content: space-between; align-items: center">
            <p class="mt-1" style="font-weight: 500; font-size: 16px">
              {{'xoay_hinh' | translate}}
            </p>
            <div style="display: flex; justify-content: space-between; gap: 4px">
              <button class="btn_transform" nz-button nzType="primary" nzSize="default"
                (click)="handleSetTransform('-z')">
                <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                <p class="m-0">{{"trai" | translate}}</p>
              </button>
              <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                (click)="handleSetTransform('z')">
                <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                <p class="m-0">{{'phai' | translate}}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item" styl="min-height: 32px">
            <p class="m-0">{{'trai' | translate}}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateZ"
              (ngModelChange)="SetTransform()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateZ"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()"></nz-slider>
        </div>
      </div>
      <br />
      <!-- Cấu hình Độ nghiêng -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div class="item">
            <p class="m-0" style="font-weight: 500; font-size: 16px">
              {{'do_nghieng' | translate}}
            </p>
          </div>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'ngang' | translate}}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_skewY"
              (ngModelChange)="SetTransform()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_skewY"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()"></nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'doc' | translate}}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_skewX"
              (ngModelChange)="SetTransform()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_skewX"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()"></nz-slider>
        </div>
      </div>
    </div>
    <!-- Mở rộng cấu hình độ bao phủ -->
    <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 3">
      <div class="field-row">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px;">{{'vi_tri_hinh_anh' | translate}}</p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'ngang' | translate}}</p>
          <nz-input-number [(ngModel)]="config.image.object_x" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"></nz-input-number>
        </div>

      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'doc' | translate}}</p>
          <nz-input-number [(ngModel)]="config.image.object_y" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"></nz-input-number>
        </div>

      </div>
      <div class="field-row">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px;">{{'thu_phong_hinh_anh' | translate}}</p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'do_co_gian' | translate}}</p>
          <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="class['image__boundary--img'].transfrom_scale"
            (ngModelChange)="scale()">
          </nz-input-number>
        </div>
        <nz-slider [(ngModel)]="class['image__boundary--img'].transfrom_scale" (nzOnAfterChange)="scale()"
          (ngModelChange)="class['image__boundary--img'].transfrom_scale" [nzMin]="0.1" [nzMax]="2"
          [nzStep]="0.1"></nz-slider>
      </div>
    </div>
  </div>
</div>
